/** A calculation's note as a reader sees it, split out of `customerWords.ts` because it prints
 * quantities through `format.ts` and that file keeps to no imports (the browser gate loads it natively).
 */

import { customerText } from "./customerWords";
import { computedQuantity, statedQuantity, unitLabel } from "./format";


/** A calculation's note as a reader sees it (Q-13; G-Wviewer-20, G-Wapprover-25).
 *
 * The engine writes its notes once, onto the figure, and rewording them there is an engine change, so
 * the receipt says them through this. Three things, each a real note the walks read:
 *
 * - `Normalised 667280 kWh to 2276.853870291598553211001004 MMBtu before applying the factor.` becomes
 *   `Converted 667,280 kWh to 2,276.854 MMBtu before applying the factor.`: a quantity is grouped, and a
 *   converted one is rounded to three places (`computedQuantity`), the same three a gas line uses;
 * - any other decimal with eight or more places is a stored scale, not a measurement, and is rounded
 *   the same way. A published factor has at most six places (`2.04536`) and is left exactly as
 *   published, because the receipt exists so a figure can be re-performed;
 * - `(verification log S-17)` and any register id or decision number are removed with the net, keeping
 *   the sentence they sat in.
 */
export function calculationNoteWords(note: string): string {
  const converted = /^Normalised (\S+) (\S+) to (\S+) (\S+) before applying the factor\.$/.exec(note);
  let said: string;
  if (converted) {
    const [, from, fromUnit, to, toUnit] = converted;
    said = `Converted ${statedQuantity(from ?? "")} ${unitLabel(fromUnit ?? "")} to ${computedQuantity(to ?? "")} ${unitLabel(toUnit ?? "")} before applying the factor.`;
  } else {
    said = note.replace(/(?<![\d.])-?\d+\.\d{8,}(?!\d)/g, (long) => computedQuantity(long));
  }
  said = said.replace(/[;,]?\s*verification log [A-Z]{1,4}-\d{2}[a-z]?/g, "").replace(/\(\s*\)/g, "");
  return customerText(said);
}
